import { createContext, useContext } from "react";
import type { NullableMaybe } from "types/utilities";
import type { ProcessedBetEntry } from "@/hooks/firestore/betting/useEntries";

type SummaryContextType = {
  entry: ProcessedBetEntry;
  currency: string;
  oddsFormat: string;
};
export const BetSummaryContext =
  createContext<NullableMaybe<SummaryContextType>>(undefined);

export const useBetSummaryContext = () => {
  const context = useContext(BetSummaryContext);

  if (!context) {
    throw new Error(
      "useBetSummaryContext must be within BetSummaryContextProvider",
    );
  }

  return context;
};
